var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shop_index"
  }, [_c('topbar'), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), (_vm.bannerItem != '') ? _c('div', {
    staticClass: "hq-shop-banner"
  }, [_c('img', {
    staticStyle: {
      "width": "1400",
      "height": "120px",
      "cursor": "pointer"
    },
    attrs: {
      "src": _vm.bannerItem.mediaCode
    },
    on: {
      "click": function($event) {
        _vm.goUrl(_vm.bannerItem.link)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hq-shop-header"
  }, [_c('div', {
    staticClass: "w1200 bc bd"
  }, [_c('ul', {
    staticClass: "hq-shop-nav"
  }, [_vm._m(0), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goShopIntroduction()
      }
    }
  }, [_vm._v("企业介绍")])])]), _vm._v(" "), _c('div', {
    staticClass: "hq-shop-zx fr"
  }, [_c('a', {
    staticClass: "a-btn-zx",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "mouseenter": function($event) {
        _vm.shopAskAndFavoriteShow()
      }
    }
  }, [_vm._v("咨询／收藏"), _c('i', {
    staticClass: "dp-ico-a-1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "zx-drop-box none",
    on: {
      "mouseleave": function($event) {
        _vm.shopAskAndFavoriteHidden()
      }
    }
  }, [_c('div', {
    staticClass: "item-1"
  }, [_c('i', {
    staticClass: "dp-ico-arrw"
  }), _vm._v(" "), _c('p', [_vm._v("店铺好评率：" + _vm._s(_vm.goodRate) + "%")]), _vm._v(" "), (_vm.shopBo.creditPoint >= 4) ? _c('p', [_c('span', {
    staticClass: "vm"
  }, [_vm._v("信用等级： ")]), _vm._v(" "), (_vm.shopBo.creditPoint >= 4 && _vm.shopBo.creditPoint <= 10) ? _c('span', {
    staticClass: "vip_rank_1 vm"
  }) : _vm._e(), _vm._v(" "), (_vm.shopBo.creditPoint >= 11 && _vm.shopBo.creditPoint <= 40) ? _c('span', {
    staticClass: "vip_rank_2 vm"
  }) : _vm._e(), _vm._v(" "), (_vm.shopBo.creditPoint >= 41 && _vm.shopBo.creditPoint <= 90) ? _c('span', {
    staticClass: "vip_rank_3 vm"
  }) : _vm._e(), _vm._v(" "), (_vm.shopBo.creditPoint >= 91 && _vm.shopBo.creditPoint <= 150) ? _c('span', {
    staticClass: "vip_rank_4 vm"
  }) : _vm._e(), _vm._v(" "), (_vm.shopBo.creditPoint >= 151 && _vm.shopBo.creditPoint <= 250) ? _c('span', {
    staticClass: "vip_rank_5 vm"
  }) : _vm._e(), _vm._v(" "), (_vm.shopBo.creditPoint >= 251 && _vm.shopBo.creditPoint <= 500) ? _c('span', {
    staticClass: "vip_rank_6 vm"
  }) : _vm._e(), _vm._v(" "), (_vm.shopBo.creditPoint >= 501 && _vm.shopBo.creditPoint <= 1000) ? _c('span', {
    staticClass: "vip_rank_7 vm"
  }) : _vm._e(), _vm._v(" "), (_vm.shopBo.creditPoint >= 1001 && _vm.shopBo.creditPoint <= 2000) ? _c('span', {
    staticClass: "vip_rank_8 vm"
  }) : _vm._e(), _vm._v(" "), (_vm.shopBo.creditPoint >= 2001 && _vm.shopBo.creditPoint <= 5000) ? _c('span', {
    staticClass: "vip_rank_9 vm"
  }) : _vm._e(), _vm._v(" "), (_vm.shopBo.creditPoint >= 5001 && _vm.shopBo.creditPoint <= 10000) ? _c('span', {
    staticClass: "vip_rank_10 vm"
  }) : _vm._e(), _vm._v(" "), (_vm.shopBo.creditPoint >= 10001 && _vm.shopBo.creditPoint <= 20000) ? _c('span', {
    staticClass: "vip_rank_11 vm"
  }) : _vm._e(), _vm._v(" "), (_vm.shopBo.creditPoint >= 20001 && _vm.shopBo.creditPoint <= 50000) ? _c('span', {
    staticClass: "vip_rank_12 vm"
  }) : _vm._e(), _vm._v(" "), (_vm.shopBo.creditPoint >= 50001 && _vm.shopBo.creditPoint <= 100000) ? _c('span', {
    staticClass: "vip_rank_13 vm"
  }) : _vm._e(), _vm._v(" "), (_vm.shopBo.creditPoint >= 100001 && _vm.shopBo.creditPoint <= 200000) ? _c('span', {
    staticClass: "vip_rank_14 vm"
  }) : _vm._e(), _vm._v(" "), (_vm.shopBo.creditPoint >= 200001) ? _c('span', {
    staticClass: "vip_rank_15"
  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "item-2"
  }, [_c('a', {
    staticClass: "a-btn-zxzx",
    attrs: {
      "href": _vm.shopBo.qq
    }
  }, [_c('i', {
    staticClass: "dp-ico-zxzx"
  }), _vm._v("在线咨询")]), _vm._v(" "), _c('a', {
    staticClass: "a-btn-scbd ml10",
    on: {
      "click": function($event) {
        _vm.addOrDeleteFavoriteShop()
      }
    }
  }, [_c('i', {
    staticClass: "dp-ico-scbd"
  }), _vm._v(_vm._s(_vm.isExistFavoriteShop == 0 ? '收藏本店' : '已经收藏'))])])])])])]), _vm._v(" "), (_vm.sliderItems != '') ? _c('div', {
    staticClass: "shop-focus-img"
  }, [_c('mt-swipe', {
    staticStyle: {
      "height": "370px",
      "cursor": "pointer"
    },
    attrs: {
      "auto": 3000,
      "speed": 1000
    }
  }, _vm._l((_vm.sliderItems), function(i, index) {
    return _c('mt-swipe-item', {
      key: index,
      style: ({
        background: 'url(' + i.mediaCode + ')' + 'no-repeat center top'
      }),
      attrs: {
        "link": i.link,
        "onclick": "jumpUrl(this)"
      },
      on: {
        "click": function($event) {
          _vm.goUrl(i.link)
        }
      }
    }, [_c('a', {
      staticStyle: {
        "display": "none"
      }
    }, [_vm._v(_vm._s(i.link))])])
  }))], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "w1200 bc",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [(_vm.noGoods) ? _c('div', {
    staticClass: "qidai"
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.firstCatList), function(shopCatBo, index) {
    return (shopCatBo.goodsList.length != 0) ? _c('div', {
      staticClass: "shop-tabbox-1 shop-jp-tj"
    }, [_c('div', {
      staticClass: "hd"
    }, [_c('ul', [_c('li', {
      staticClass: "hover"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.getCatGoods('', shopCatBo.catCode)
        }
      }
    }, [_vm._v(_vm._s(shopCatBo.catNameCn))])]), _vm._v(" "), _c('ul', {
      staticClass: "tags"
    }, [_c('a', {
      staticClass: "more",
      on: {
        "click": function($event) {
          _vm.getMore(shopCatBo.catCode, shopCatBo.catNameCn)
        }
      }
    }, [_vm._v("更多 >")]), _vm._v(" "), _vm._l((shopCatBo.childCatList), function(childCatBo) {
      return _c('li', [_c('a', {
        attrs: {
          "href": "javascript:void(0);"
        },
        on: {
          "click": function($event) {
            _vm.getCatGoods(childCatBo.catCode, shopCatBo.catCode)
          }
        }
      }, [_vm._v(_vm._s(childCatBo.catNameCn))])])
    })], 2)])]), _vm._v(" "), (shopCatBo.catCode != 'spike') ? _c('div', {
      staticClass: "bd"
    }, [_c('ul', {
      attrs: {
        "id": shopCatBo.catCode
      }
    }, _vm._l((shopCatBo.goodsList), function(goodsBo, index) {
      return (index < 8) ? _c('li', [_c('p', {
        staticClass: "pic tc"
      }, [_c('a', {
        on: {
          "click": function($event) {
            _vm.goDetail(goodsBo.goodsCode)
          }
        }
      }, [_c('img', {
        attrs: {
          "src": _vm.profixPath + (goodsBo.imgMiddle != null ? (goodsBo.imgMiddle.split(';'))[0] : ''),
          "width": "265",
          "height": "265"
        }
      })])]), _vm._v(" "), _c('p', {
        staticClass: "title"
      }, [_c('a', {
        on: {
          "click": function($event) {
            _vm.goDetail(goodsBo.goodsCode)
          }
        }
      }, [_vm._v(_vm._s(goodsBo.goodsName))])]), _vm._v(" "), (goodsBo.goodsPrice == 0) ? _c('p', {
        staticClass: "other"
      }, [_c('span', {
        staticClass: "price"
      }, [_vm._v("¥" + _vm._s(goodsBo.unitPrice / 100))])]) : _c('p', {
        staticClass: "other"
      }, [_c('span', {
        staticClass: "price"
      }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(goodsBo.goodsPrice) + "\n\t\t\t\t\t\t\t\t\t"), (goodsBo.pointType == 'point') ? _c('span', [_vm._v("积分")]) : (goodsBo.pointType == 'special') ? _c('span', [_vm._v("专用积分")]) : (goodsBo.pointType == 'red') ? _c('span', [_vm._v("红积分")]) : (goodsBo.pointType == 'blue') ? _c('span', [_vm._v("蓝积分")]) : _vm._e()])])]) : _vm._e()
    }))]) : _vm._e(), _vm._v(" "), (shopCatBo.catCode == 'spike') ? _c('div', {
      staticClass: "bd"
    }, [_c('ul', {
      staticClass: "miaosha-ul",
      attrs: {
        "id": shopCatBo.catCode
      }
    }, _vm._l((shopCatBo.goodsList), function(goodsBo) {
      return _c('li', [_c('p', {
        staticClass: "pic tc"
      }, [_c('a', {
        on: {
          "click": function($event) {
            _vm.goDetail(goodsBo.goodsCode)
          }
        }
      }, [_c('img', {
        attrs: {
          "src": _vm.profixPath + goodsBo.imgMiddle,
          "width": "265",
          "height": "265"
        }
      })])]), _vm._v(" "), _c('p', {
        staticClass: "title"
      }, [_c('a', {
        on: {
          "click": function($event) {
            _vm.goDetail(goodsBo.goodsCode)
          }
        }
      }, [_vm._v(_vm._s(goodsBo.goodsName))])]), _vm._v(" "), _c('div', {
        staticClass: "line-price"
      }, [_c('span', {
        staticClass: "co3"
      }, [_vm._v("¥" + _vm._s(goodsBo.unitPrice / 100))]), _c('span', {
        staticClass: "old"
      }, [_vm._v("¥" + _vm._s(goodsBo.marketPrice / 100))])]), _vm._v(" "), _c('div', {
        staticClass: "pinpainow_item_time"
      }, [(goodsBo.saleStatus === 'end') ? _c('span', {
        staticClass: "brandsknow_time_txt"
      }, [_vm._v("                         \n                \t\t\t\t已结束                       \n                \t\t\t")]) : _vm._e(), _vm._v(" "), (goodsBo.saleStatus === 'wait_start') ? _c('span', {
        staticClass: "brandsknow_time_txt"
      }, [_vm._v("                         \n                \t\t\t\t距开始 "), _c('i', {
        staticClass: "brandsknow_time_txt_time"
      }, [_vm._v(_vm._s(goodsBo.hour))]), _vm._v("时"), _c('i', {
        staticClass: "brandsknow_time_txt_time"
      }, [_vm._v(_vm._s(goodsBo.minute))]), _vm._v("分"), _c('i', {
        staticClass: "brandsknow_time_txt_time"
      }, [_vm._v(_vm._s(goodsBo.second))]), _vm._v("秒                        \n                \t\t\t")]) : _vm._e(), _vm._v(" "), (goodsBo.saleStatus === 'on_sale') ? _c('span', {
        staticClass: "brandsknow_time_txt"
      }, [_vm._v("                         \n                \t\t\t\t距结束 "), _c('i', {
        staticClass: "brandsknow_time_txt_time"
      }, [_vm._v(_vm._s(goodsBo.hour))]), _vm._v("时"), _c('i', {
        staticClass: "brandsknow_time_txt_time"
      }, [_vm._v(_vm._s(goodsBo.minute))]), _vm._v("分"), _c('i', {
        staticClass: "brandsknow_time_txt_time"
      }, [_vm._v(_vm._s(goodsBo.second))]), _vm._v("秒                        \n                \t\t\t")]) : _vm._e()])])
    }))]) : _vm._e(), _vm._v(" "), (index == 0 && _vm.adsItem != '') ? _c('div', {
      staticClass: "mt20"
    }, [_c('a', {
      attrs: {
        "href": _vm.adsItem.link
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.adsItem.mediaCode,
        "width": "1200",
        "height": "390"
      }
    })])]) : _vm._e()]) : _vm._e()
  })], 2), _vm._v(" "), (_vm.bottomAdsItem != '') ? _c('div', {
    staticStyle: {
      "padding-bottom": "0.8rem",
      "width": "1200px",
      "margin": "auto"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.bottomAdsItem.link
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.bottomAdsItem.mediaCode,
      "width": "1200",
      "height": "60"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('footermenu'), _vm._v(" "), _c('footercopyright')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "hover"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("首页")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ab16012","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/shop/shop_index.vue
// module id = Qo9D
// module chunks = 1